import { ReactNode, useContext } from "react"
import styled, { useTheme } from "styled-components"
// https://blog.logrocket.com/create-responsive-navbar-react-css/
// https://dev.to/jsandaruwan/building-a-responsive-navigation-bar-with-react-5ban
import { CaretDownOutlined } from "@ant-design/icons"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { App, Dropdown, Grid, MenuProps, Space } from "antd"
import { NavLink, NavLinkProps, useLocation, useNavigate } from "react-router-dom"
import { refreshSessionUser } from "../config"
import { UserContext, UserDispatchContext } from "../context"
import { useMenuContext } from "../context/MenuContext"
import { exitImpersonation, logout } from "../endpoints"
import "./css/Header.css"

const NavLinkStyled = styled(NavLink)`
    text-decoration: none;

    color: ${(props) => props.theme.primary};
    font-size: 1rem;
`
const LogoBox = styled.div`
    border-radius: 25px;
    /* background: ${(props) => props.theme.background}; */
    padding: 6px;
    padding-left: 1.5em;
    text-align: center;
    /* width: 14em; */
    /* height: 1.2em; */
    vertical-align: middle;
`
const MenuBox = styled.div`
    border-radius: 25px;
    background: transparent; 
    // ${(props) => props.theme.background};
    padding: 6px;
    text-align: center;
    padding-right: 2em;
    /* width: 14em; */
    /* height: 1.2em; */
    vertical-align: middle;
`
const LogoText1 = styled.span`
    font-size: 1.5rem;
    font-weight: bold;
    font-style: italic;
    color: ${(props) => props.theme.primary};
    font-family: var(--logo-font-regular);
    margin: 0;
`
const LogoText2 = styled.span`
    font-size: 1.5rem;
    font-weight: bold;
    color: ${(props) => props.theme.primary};
    font-family: var(--logo-font);
    margin: 0;
`
const Logo = () => {
    return (
        <LogoBox>
            <NavLink2 to="/home">
                <LogoText1>PLAB</LogoText1>
                <LogoText2> Sequencing</LogoText2>
            </NavLink2>
        </LogoBox>
    )
}
interface NavLink2Props extends NavLinkProps {
    children: ReactNode
}
const NavLink2 = ({ children, ...props }: NavLink2Props): JSX.Element => {
    const { setShowMenu } = useMenuContext()
    
    const handleClick = () => {
        setShowMenu(false)
    }
    
    return (
        <div>
            <NavLinkStyled onClick={handleClick} {...props}>
                {children}{" "}
            </NavLinkStyled>
        </div>
    )
}

const LoginMenu = () => {
    const { message: messageApi } = App.useApp()
    const dispatch = useContext(UserDispatchContext)
    const navigate = useNavigate()
    const theme = useTheme()
    const user = useContext(UserContext)
    const { setShowMenu } = useMenuContext()
    const userDropdowns: MenuProps["items"] = [
        {
            key: "4",
            label: (
                <div
                    className="login-tag"
                    onClick={async () => {
                        navigate("/myspace/profile")
                        setShowMenu(false)
                    }}
                >
                    Profile
                </div>
            ),
        },
        {
            key: "2",
            label: (
                <div
                    className="login-tag"
                    onClick={async () => {
                        navigate("/changepassword")
                        setShowMenu(false)
                    }}
                >
                    Change Password
                </div>
            ),
        },

        {
            key: "3",
            label: (
                <div
                    className="login-tag"
                    onClick={async () => {
                        const result = await logout()
                        if (result.code === 1000) {
                            messageApi.success({ content: "You have successfully logged out." })
                            dispatch?.({
                                type: "LOGOUT",
                                payload: { user: null, supervisor: null },
                            })
                        }
                        navigate("/", { replace: true })
                        setShowMenu(false)
                    }}
                >
                    Log Out
                </div>
            ),
        },
    ]
    if (user.supervisor?.email) {
        // console.log(user.supervisor)
        userDropdowns.unshift({
            key: "1",
            label: (
                <div
                    className="login-tag"
                    onClick={async () => {
                        const result = await exitImpersonation()
                        if (result.code === 1000) {
                            refreshSessionUser(result.userInSession, dispatch)
                            window.location.href = "/"
                        }
                        setShowMenu(false)
                    }}
                >
                    Exit impersonation
                </div>
            ),
        })
    }
    if (user.user)
        return (
            <Dropdown menu={{ items: userDropdowns }}>
                <Space>
                    <span style={{ fontSize: "1rem", color: theme.primary }}>
                        {" "}
                        {(user.supervisor ? "[" : "") +
                            user.user?.firstName +
                            " " +
                            user.user?.lastName +
                            (user.supervisor ? "]" : "")}
                             <span style={{ marginLeft: 8 }}></span>

                        <CaretDownOutlined />
                    </span>
                </Space>
            </Dropdown>
        )
    return (
        <NavLink2 to="/login" style={{ color: theme.primary}}>
            Login
        </NavLink2>
    )
}
export const Header = () => {
    const location = useLocation()
    const { useBreakpoint } = Grid
    const screens = useBreakpoint()
    const theme = useTheme()
    const { showMenu, toggleMenu } = useMenuContext()

    const user = useContext(UserContext)
    /* console.log(user) */
    // console.log(screens)
    return (
        <nav className="nav container" style={{ backgroundColor: theme.white }}>
            <Logo />
            <div
                className={`nav__menu ${showMenu ? "show-menu" : ""}`}
                style={{ backgroundColor: !screens.md ? theme.background : "transparent" }}
                id="nav-menu"
            >
                <MenuBox>
                    <ul className="nav__list">
                        {user.user && (
                            <li>
                                <NavLink2 to="/myspace">My Space</NavLink2>
                            </li>
                        )}
                        {location.pathname !== "/login" && location.pathname !== "/register" && (
                        <li>
                            <LoginMenu />
                        </li>
                        )}
                    </ul>
                </MenuBox>
                <div className="nav__close" id="nav-close" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faTimes} style={{ color: theme.primary }} />
                </div>
            </div>

            <div className="nav__toggle" id="nav-toggle" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faBars} style={{ color: theme.primary }} />
            </div>
        </nav>
    )
}
